// extracted by mini-css-extract-plugin
module.exports = {"footer":"dd31006766--footer--y1nfe"};